import type { GenericValidator } from "pages/TeacherEnvironment/TeacherDashboard/subpages/ScheduledTestWizard/validate";
import * as Yup from "yup";

export const createValidationSchema = (): GenericValidator =>
  Yup.object({
    message: Yup.string().defined(),
  });
